"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var index_1 = require("../../../../../client/src/index");
if (process.env.NODE_ENV === 'development') {
    // Run react-axe in development only, so it does not affect performance
    // in production, and does not break unit tests either.
    // eslint-disable-next-line global-require
    var axe = require('react-axe');
    axe(react_1["default"], react_dom_1["default"], 1000);
}
// Expose components as globals for third-party reuse.
window.wagtail.components = {
    Icon: index_1.Icon,
    Portal: index_1.Portal,
};
/**
 * Add in here code to run once the page is loaded.
 */
document.addEventListener('DOMContentLoaded', function () {
    var explorerNode = document.querySelector('[data-explorer-menu]');
    var toggleNode = document.querySelector('[data-explorer-start-page]');
    if (explorerNode && toggleNode) {
        index_1.initExplorer(explorerNode, toggleNode);
    }
    index_1.initFocusOutline();
    index_1.initSubmenus();
    index_1.initIE11Warning();
    index_1.initUpgradeNotification();
    index_1.initSkipLink();
});
